import { MenuItem } from '@mui/material';
import { Add as AddIcon, FileUpload as FileUploadIcon } from '@mui/icons-material';

import {
  CustomAutoComplete,
  CustomButton,
  HorizontalForm,
} from '../../../../common/components';
import { ADJUSTMENT_TYPE_OPTIONS, compactFormSx } from '../../constants/supplierLedgerUiConstants';

const AdjustmentsToolbar = ({
  filters,
  onChange,
  onOpenDrawer,
  onOpenImport,
  providerOptions,
}) => (
  <HorizontalForm withBorder={false} sx={compactFormSx}>
    <CustomButton variant="base" startIcon={<AddIcon />} onClick={onOpenDrawer}>Nuevo ajuste</CustomButton>
    <CustomButton variant="outlined" startIcon={<FileUploadIcon />} onClick={onOpenImport}>Importar saldos</CustomButton>
    <CustomAutoComplete
      label="Proveedor"
      name="uuid_legal_entity"
      value={filters.uuid_legal_entity}
      onChange={onChange}
      options={[{ value: '', label: 'Todos' }, ...providerOptions]}
      sx={{ width: 320 }}
    />
    <CustomAutoComplete label="Tipo" name="adjustment_type" value={filters.adjustment_type} onChange={onChange} sx={{ width: 220 }}>
      <MenuItem value="">Todos</MenuItem>
      {ADJUSTMENT_TYPE_OPTIONS.map((option) => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
    </CustomAutoComplete>
    <CustomAutoComplete label="Estado" name="status" value={filters.status} onChange={onChange} sx={{ width: 180 }}>
      <MenuItem value="">Todos</MenuItem>
      <MenuItem value="active">Activo</MenuItem>
      <MenuItem value="cancelled">Anulado</MenuItem>
    </CustomAutoComplete>
  </HorizontalForm>
);

export default AdjustmentsToolbar;
